<template>
  <div class="kt-header__topbar">
    <div
      class="kt-header__topbar-item kt-header__topbar-item--upload dialog mr-3"
      id="kt_quick_upload_toggle"
      v-bind="attrs"
      v-on="on"
    >
      <div :class="isMobile ? 'mx-3' : 'mt-3 mr-3 '" style="display: none">
        <v-btn outlined :color="black" @click="toggleUploadDialog">
          <v-icon left small>fal fa-plus</v-icon>
          Create Content
        </v-btn>
      </div>
    </div>
    <upload-dialog
      style="display: none"
      :toggle-upload-dialog="toggleUploadDialog"
      :add-upload-dialog="addUploadDialog"
      :close-dialog="closeDialog"
    >
    </upload-dialog>
    <!-- <search-dialog style="display: none" /> -->
    <user-switcher-dialog v-if="isCurrentUserSuperAdmin" />
    <top-notification style="display: none" />
    <top-apps-menu />
    <top-user />
  </div>
</template>
<script>
import { some as _some } from 'lodash-es';
import UploadDialog from '@/components/partials/_header/UploadDialog.vue';
import SearchDialog from '@/components/partials/_header/SearchDialog.vue';
import UserSwitcherDialog from '@/components/partials/_header/UserSwitcherDialog.vue';
import TopUser from './TopUser.vue';
import TopNotification from './TopNotification.vue';
import AddUnitDialog from '@/components/partials/_header/AddUnitDialog';
import TopAppsMenu from './TopAppsMenu.vue';

export default {
  name: 'TopBase',
  components: {
    UserSwitcherDialog,
    SearchDialog,
    TopUser,
    TopNotification,
    UploadDialog,
    TopAppsMenu,
  },
  data() {
    return {
      canAdd: false,
      addUploadDialog: false,
    };
  },
  created() {
    this.setProfile(this.$auth.user());
  },
  computed: {
    roles() {
      return this.$auth.user().roles;
    },
    isCurrentUserSuperAdmin() {
      return _some(this.roles, { name: 'super-administrator' });
    },
    isCurrentUserManager() {
      return (
        _some(this.roles, { name: 'account-manager' }) ||
        _some(this.roles, { name: 'specific-dealer-manager' })
      );
    },
    canAdd() {
      return this.isCurrentUserSuperAdmin || this.isCurrentUserManager;
    },
  },
  methods: {
    setProfile(profile) {
      this.$store.commit('profile/setProfile', {
        id: profile.id,
        name: profile.name,
        email: profile.email,
        profilePicture: profile.profile_picture,
        jobTitle: profile.position ? profile.position.friendly_name : 'N/A',
        phone: profile.phone_number,
      });
      this.$store.commit('profile/setCompany', profile.dealer);
    },
    toggleUploadDialog() {
      this.addUploadDialog = !this.addUploadDialog;
    },
    closeDialog() {
      this.addUploadDialog = false;
    },
  },
};
</script>
